import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core';
import { SignaturePad } from 'angular2-signaturepad';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit, AfterViewInit {

  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  signaturePadOptions = {
    minWidth: 2,
    canvasWidth: 500,
    canvasHeight: 200
  };

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    dateClick: this.handleDateClick.bind(this),
  };

  constructor() { }

  ngOnInit(){}

  handleDateClick(arg) {
    console.log('date click!', arg.dateStr)
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.signaturePad) {
        this.signaturePad.clear();
      } else {
        console.error('SignaturePad is STILL undefined');
      }
    }, 0);
  }

  drawComplete() {}

  clear() {
    this.signaturePad.clear();
  }

  save() {
    const base64 = this.signaturePad.toDataURL();
    console.log(base64);
  }

}
